import { render, staticRenderFns } from "./EstadoCivilPage.vue?vue&type=template&id=2138e871"
import script from "./EstadoCivilPage.js?vue&type=script&lang=js&external"
export * from "./EstadoCivilPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports